import { render, staticRenderFns } from "./dashboard2.vue?vue&type=template&id=8d00cbee&scoped=true&"
import script from "./dashboard2.vue?vue&type=script&lang=js&"
export * from "./dashboard2.vue?vue&type=script&lang=js&"
import style0 from "./dashboard2.vue?vue&type=style&index=0&id=8d00cbee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d00cbee",
  null
  
)

export default component.exports